import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/styles";
import { Hidden } from "@material-ui/core";

const useStyles = makeStyles({
  uppercase: {
    textTransform: "uppercase"
  }
});

function ThickThinTitle(props) {
  const classes = useStyles();
  const { content } = props;
  const {
    color,
    gradientColor,
    thickText,
    thinText,
    variant,
    switchWeights,
    uppercase,
    splitOnMobile
  } = content;

  return (
    <>
      <Typography
        variant={variant || "h2"}
        color={color}
        className={uppercase && classes.uppercase}
      >
        <Box fontWeight={switchWeights ? "300" : "700"} display="inline">
          {thickText}
        </Box>

        {splitOnMobile && (
          <Hidden smUp>
            <br />
          </Hidden>
        )}

        <Box fontWeight={switchWeights ? "700" : "300"} display="inline">
          {thinText}
        </Box>
      </Typography>
    </>
  );
}

export default ThickThinTitle;
